// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BankTransactionType } from './bank-transaction-type';
import { OnlineContribution } from './online-contribution';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BankTransaction extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get contributionList() {
        let list = null;
        if (!!this.onlineContributions && this.onlineContributions.length > 0) {
            list = 'Linked';
            // this.onlineContributions.forEach(x => {
            //     list.push(x.id);
            // });
        }

        // return list.join('; ');
        return list;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountNumber?: string;
  assignedMonth?: Date;
  balance?: number;
  bankTransactionTypeId!: number;
  check?: string;
  claimed?: Date;
  claimedBy?: string;
  created?: Date;
  credit?: number;
  debit?: number;
  deleted?: Date;
  description?: string;
  postDate!: Date;
  processed?: Date;
  status?: string;
  bankTransactionType!: BankTransactionType;
  onlineContributions!: OnlineContribution[];
}

